import React, { useCallback, useState } from "react";
import { CloseOutlined, FieldTimeOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { LoadStatus } from "@/utils/enum";
import MoreMenu from "@/components/MoreMenu";
import CancelLoadModal from "./CancelLoadModal";
import ChangeDriverModal from "./ChangeDriverModal";
import ChangeETAModal from "./ChangeETAModal";

const LoadActionsButton = ({ loadData, refreshPageData, hideOptions = [] }) => {
  const [changeDriverModalOpen, setChangeDriverModalOpen] = useState(false);
  const [etaChangeModalOpen, setETAChangeModalOpen] = useState(false);
  const [cancellationModalOpen, setCancellationModalOpen] = useState(false);

  const onMenuItemClick = useCallback(key => {
    switch (key) {
      case "change-driver":
        setChangeDriverModalOpen(true);
        break;

      case "change-eta":
        setETAChangeModalOpen(true);
        break;

      case "cancel":
        setCancellationModalOpen(true);
        break;

      default:
        break;
    }
  }, []);

  const options = [
    {
      key: "change-driver",
      label: "Change Driver",
      icon: <UserSwitchOutlined />,
      authority: "CoreService.AssignedLoads.ChangeDriver",
    },
    {
      key: "change-eta",
      label: "Change ETA Request",
      icon: <FieldTimeOutlined />,
      authority: "CoreService.AssignedLoads.RequestCancel",
    },
    {
      key: "cancel",
      danger: true,
      label: "Cancellation Request",
      icon: <CloseOutlined />,
      authority: "CoreService.AssignedLoads.RequestETAChange",
    },
  ];

  return (
    <>
      <MoreMenu
        disabled={loadData.status >= LoadStatus.Delivered}
        onItemClick={onMenuItemClick}
        items={hideOptions.length === 0 ? options : options.filter(option => !hideOptions.includes(option.key))}
      />

      <ChangeDriverModal
        visible={changeDriverModalOpen}
        loadData={loadData}
        refreshPageData={refreshPageData}
        onClose={() => setChangeDriverModalOpen(false)}
      />

      <ChangeETAModal visible={etaChangeModalOpen} loadData={loadData} onClose={() => setETAChangeModalOpen(false)} />

      <CancelLoadModal
        visible={cancellationModalOpen}
        loadId={loadData.id}
        onClose={() => setCancellationModalOpen(false)}
      />
    </>
  );
};

export default LoadActionsButton;
